export default "__VITE_ASSET__BzElvR9X__"